import mobileAppBridge from 'app/libs/MobileAppBridge';
import { uaParser as ua } from '@encarpkg/shared';

function appsflyerEvent(eventName) {
	if (!eventName) {
		throw new Error('Appsflyer EventName is Required');
	}

	if (ua().isApp) {
		mobileAppBridge().sendAppsflyerEvent(eventName);
	} else {
		let count = 0;

		const intervalId = setInterval(() => {
			const { AF } = window;

			if (AF) {
				AF('pba', 'event', { eventType: 'EVENT', eventName });
				clearInterval(intervalId);
			}

			try {
				count += 1;
				if (count > 50) {
					clearInterval(intervalId);
					throw new Error('Appsflyer 스크립트 로드 오류');
				}
			} catch (err) {
				console.log(err.message);
			}
		}, 100);
	}
}

export default appsflyerEvent;
